export class CmmntyDocWriteValidation {
  isTitleEmpty: boolean = false;
  isDescEmpty: boolean = false;
  isCtgryEmpty: boolean = false;
  isEmptyApprUserEmail: boolean = false;
  isEmptyApprMessage: boolean = false;
  isVersionInvalid: boolean = false;
  isVersionAlreadyExist: boolean = false;
  isEmptySwServiceImg: boolean = false;
  isEmptySwServiceLink1: boolean = false;
  isEmptySwServiceLink2: boolean = false;
  isVersionUse: boolean = false;
  isVersionDes: boolean = false;
  isVersionFile: boolean = false;
  isVersionFileDel: boolean = false;
  isInquiryCateEmpty: boolean = false;
  isInquiryTypeEmpty: boolean = false;

  //
  isVersionEmpty = false;
  isVersionDesEmpty = false;
  isVersionFileEmpty = false;
  isVersionFileDelEmpty = false;
}

export interface ICmmntyDocWriteValidation extends CmmntyDocWriteValidation {}

export type CMMNTY_WRITE_PAGE_TYPE = 'NEW' | 'TEMP' | 'APPROVAL';
export type DOC_GRP =
  | 'blog'
  | 'info'
  | 'sample'
  | 'qna'
  | 'appnote'
  | 'doc'
  | 'rndnoti'
  | 'rndqna'
  | 'rndtalk'
  | 'partnernoti'
  | 'partnerqna';

export interface IfCmmntyDocWritePageState {
  // showReqApprPopup: boolean;
  // apprMessage: string;
  // apprUserEmail: string;
  // isLoadingRequest: boolean;
  // running: boolean;
  // modifierName: string;
  // modifierNickName: string;
  // modifierEmail: string;

  // registTime?: string;

  // managerId: string;
  // partnerId: number;
  // partnerName: string;
  // mngrNickName: string;
  // managerIds: string[];

  //--
  showPreviewPopup: boolean;
  showCommentPopup: boolean;
  showEditor: boolean;
  isMounted: boolean;
  notFound: boolean;
  isPageLoading: boolean;
  relatedDocs: any[];
  isLoadingRelatedQna: boolean;
}

export class CmmntyDocWritePageState implements IfCmmntyDocWritePageState {
  // showReqApprPopup = false;
  // apprMessage = "";
  // apprUserEmail = "";
  // isLoadingRequest = false;
  // running = false;
  // modifierName = "";
  // modifierNickName = "";
  // modifierEmail = "";

  // registTime?: string;

  // managerId = '';
  // partnerId = 0;
  // partnerName = '';
  // mngrNickName = '';
  // managerIds = [];

  //--
  showPreviewPopup = false;
  showCommentPopup = undefined;
  showEditor = true;
  isMounted = false;
  notFound = false;
  isPageLoading = false;
  relatedDocs: any[] = [];
  isLoadingRelatedQna: boolean = false;
}
